// extracted by mini-css-extract-plugin
export default {"panel":"popup_panel__5aL6h","overlay":"popup_overlay__o-u-l","close":"popup_close__CsO8R"};